import React, { useState, useEffect } from "react";
import CartPathSettingIcon from "assets/svgIcons/AdminDashboard/CartPathNewIcon";
import { useDispatch, useSelector } from "react-redux";
import { COMMON_SERVICES } from "redux/reduxToolkitServices/_commonServices/commonServices";
import { useHookstate } from "@hookstate/core";
import {
  GlobalCourseIdState,
  SITEID_GLOBAL_STATE,
} from "globalStore/globalStore";
import { useTranslation } from "react-i18next";
import { API_STATUSES } from "redux/_helpers/statuses";

const TodayCartPathRule = () => {
  const { t } = useTranslation();
  const { resetGlobalCourseId } = useHookstate(GlobalCourseIdState);
  const { siteId } = useHookstate(SITEID_GLOBAL_STATE);
  const dispatch = useDispatch();
  const [siteDataState, setSiteDataState] = useState({});
  const [getDashboardCartPathDetailState, setGetDashboardCartPathDetailState] =
    useState([]);

  const {
    getDashboardCartPathDetailData,
    siteSettingsData,
    getDashboardFeatureSetStatus,
  } = useSelector((state) => state.commonReducers) || "";

  useEffect(() => {
    if (
      getDashboardFeatureSetStatus === API_STATUSES.SUCCESS &&
      siteId.get() !== null
    ) {
      dispatch(
        COMMON_SERVICES.getDashboardCartPathDetailServices(
          siteId.get(),
          localStorage.getItem("dashCourseId")
        )
      );
      setSiteDataState(siteSettingsData);
    }
  }, [
    getDashboardFeatureSetStatus,
    localStorage.getItem("dashCourseId"),
    siteId.get(),
    resetGlobalCourseId.get(),
  ]);

  useEffect(() => {
    setSiteDataState(siteSettingsData);
    setGetDashboardCartPathDetailState(getDashboardCartPathDetailData);
  }, []);

  useEffect(() => {
    setGetDashboardCartPathDetailState(getDashboardCartPathDetailData);
    setSiteDataState(siteSettingsData);
  }, [getDashboardCartPathDetailData]);

  let getCourseName =
    siteSettingsData &&
    siteSettingsData?.Courses?.filter(
      (item) => item?.Number === parseInt(localStorage.getItem("dashCourseId"))
    );

  let defaultCourseName =
    siteSettingsData && Object.keys(siteSettingsData).length > 0
      ? siteSettingsData?.Courses[0]?.Name
      : null;

  const holes = () => {
    if (siteSettingsData && Object.keys(siteSettingsData).length !== 0) {
      let data = siteSettingsData && siteSettingsData?.Courses;
      let obj = data.find((o) => o?.Id === siteSettingsData?.Courses[0]?.Id);
      let holeNumber = obj?.HoleCount;
      let enabeldData =
        getDashboardCartPathDetailData &&
        getDashboardCartPathDetailData.map((item) => item.Hole);
      let enabeldData2 =
        getDashboardCartPathDetailData &&
        getDashboardCartPathDetailData.map((item) => ({
          hole: item.Hole,
          Enabled: true,
        }));
      let newData = [...Array(holeNumber)].map((elementInArray, index) => ({
        hole: index + 1,
        Enabled: false,
      }));

      let updateData = newData
        .map((item) => item)
        .filter((el) => !enabeldData.includes(el.hole));
      updateData.push(enabeldData2);
      let sortOrder = updateData.flat();
      sortOrder.sort((a, b) => a.hole - b.hole);
      return sortOrder;
    }
  };

  return (
    <div className="h-100" style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
      <div className="header">
        <CartPathSettingIcon color="#666" />
        <p className="red-border">{t("Todays_Cart_Path_Rule")}</p>
      </div>
      <div className="box-body cart-path-rule" style={{ flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <div>
          <div className="holes-data">
            <p>
              {holes() !== undefined && holes()?.length} {t("Holes")}
            </p>
          </div>
          <div className="holes">
            {holes() &&
              holes() !== null &&
              holes().length > 0 &&
              holes()?.map((item, key) => (
                <button
                  className={item?.Enabled === true ? "selected" : ""}
                  key={key}
                >
                  {item?.hole}
                </button>
              ))}
          </div>
        </div>

        <p className="city">
          {getCourseName &&
            getCourseName !== undefined &&
            getCourseName.length !== 0
            ? getCourseName[0]?.Name
            : defaultCourseName}
        </p>
      </div>
    </div>
  );
};

export default TodayCartPathRule;
